
import { defineComponent } from "vue";
import Tickets from "../components/Billing.vue";

export default defineComponent({
  components: {
    Tickets,
  },
});
